module.exports = __webpack_public_path__ + "img/32ne.446a22df.svg";